import { useRef, useEffect } from 'react';

import classNames from 'classnames';

import getExtensionFromName from './getExtensionFromName';

import useStyles from './styles';

type VideoPreviewProps = {
  src: string;
  className?: string;
};

function getMimeTypeFromSrc(src: string) {
  return `video/${getExtensionFromName(src)}`;
}

export default function VideoPreview({ src, className }: VideoPreviewProps) {
  const videoRef = useRef(null);
  const classes = useStyles();

  useEffect(() => {
    if (videoRef.current) {
      const promise = videoRef.current.play();

      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      promise &&
        promise.catch((err: DOMException) => {
          console.error('Play error:', err);
        });
    }
  }, []);

  return (
    <video
      className={classNames([classes.root, className])}
      ref={videoRef}
      loop
      muted
      data-testid="vid-preview"
    >
      <source src={src} type={getMimeTypeFromSrc(src)} />
      Your browser does not support the video tag.
    </video>
  );
}
